
mainApp.component('socketConfiguration', {
    templateUrl: '/public/components/socket-configuration.component.html',
    bindings: {
        siteId: '<',
        siteName: '<',
        linkDestinationChangeListener: '&',
        showSerialLabel: '<',
        showUnassignButton: '<',
        isSiteHa: '<',
        socketSettings: '=',
        secondarySocketSettings: '=',
        offCloudSupportedInNic: '&',
        linksSwapListener: '&',
        precedenceChangeListener: '&?',
        nameChangeListener: '&'
    },
    controller: socketConfigurationController
});

function socketConfigurationController($scope,$timeout) {
    let ctrl = this;
    let DEFAULT_MIN_LINK_VALUE = 1;
    let MAX_NUM_OF_LAN_LAG_MASTER_MSG = "You can only define 1 link as the LAN LAG Master";
    let MIN_NUM_OF_LAN_LAG_MASTER_MSG = "Define the LAN LAG Master link before you add member links";
    let MAX_NUM_OF_LAN_LAG_MEMBER_MSG = "Each LAG supports up to 4 LAN member links (master link also counts as a member)";
    let MAX_NUM_OF_LAN_LAN_MSG = "Each LAG supports up to 4 links (including a master and members)";
    let MAX_NUM_OF_VRRP_MSG = "Can only configure one VRRP";

    ctrl.$onInit = function() {
        ctrl.linkHover = null;
        ctrl.currentLink = null;
        ctrl.lanLagMinLinkArr = [1,2,3,4];
        initPrecedence();
    };

    const initPrecedence = () => {
        ctrl.precedences = {
            1: '1 (Active)',
            2: '2 (Passive)',
            3: '3 (Last-resort)'
        };
    }

    ctrl.roles = {
        wan_1: 'WAN 1',
        wan_2: 'WAN 2',
        wan_3: 'WAN 3',
    };

    ctrl.addOnInterfaceIds = ["9", "10", "11", "12"];

    ctrl.enableOptions = [{ name: 'Disabled', val: false }, { name: 'Enabled', val: true }];

    // listens to selection / hover events that are coming from the socket-illustration inner component
    ctrl.eventListener = function(type, linkId) {
        if (type === 'hover')
            ctrl.linkHover = linkId;
        if (type === 'selected')
            ctrl.currentLink = linkId;
    };

    // returns the style class for a link line
    ctrl.getStyle = function(linkData) {
        if (ctrl.currentLink === linkData.interface_id)
            return 'selected';
        if (ctrl.linkHover === linkData.interface_id)
            return 'hover'
        return '';
    };

    ctrl.setCurrentLink = function(linkId){
        ctrl.currentLink = linkId;
    };

    ctrl.clearCurrentLink = function(){
        ctrl.currentLink = null;
    };

    ctrl.initDestType = function(linkData){
        linkData.destType = linkData.metadata.supportedDestinations.filter(dest => dest.name === linkData.destType.name)[0];
    }

    ctrl.initLanLagMinLinks = function(linkData){
        linkData.lanLagMinLinks = linkData.lanLagMinLinks ? linkData.lanLagMinLinks : DEFAULT_MIN_LINK_VALUE;
    }

    ctrl.initVrrpPortConnType = function(linkData){
        if (linkData.vrrpPortConnType){
            linkData.vrrpPortConnType = ctrl.socketSettings.supportedVrrpPortConnType.filter(vrrpPortConnType => vrrpPortConnType.name === linkData.vrrpPortConnType.name)[0];
        }else{
            linkData.vrrpPortConnType = ctrl.socketSettings.supportedVrrpPortConnType[0];
        }
    }

    ctrl.disableDestTypeChange = function(linkData){
        let shouldDisable = linkData.metadata.disabledDestType;

        if (ctrl.socketSettings.type.value === 'X1700'){
            shouldDisable = disablePortOnSocketX1700(linkData.metadata.disabledDestType, linkData)
        } else if (ctrl.socketSettings.type.value === 'X1500'){
            shouldDisable = disablePortOnSocketX1500(linkData.metadata.disabledDestType, linkData)
        }


        return shouldDisable;
    }

    /**
     * Port 1 on X1700 should not be disabled in the following scenarios:
     * 1. CATO dest type configured on an add-on port
     * 2. IEPL dest type is configured on any port
     * 3. CATO dest type is NOT configured on an add-on port and Port 1 is not set to CATO
     */
    let disablePortOnSocketX1700 = (disabledDestType, linkData) => {
        if (linkData.interface_id === '1'){
            return isPortSetToCato(linkData) && !hasCatoLinkOnAddOn() && !hasIeplLink();
        } else {
            return disabledDestType;
        }
    }

    /**
     * Port wan 1 on X1500 should not be disabled in the following scenario:
     * 1. IEPL dest type is configured on any port
     */
    let disablePortOnSocketX1500 = (disabledDestType, linkData) => {
        if (linkData.interface_id === 'WAN1'){
            return !hasIeplLink();
        } else {
            return disabledDestType;
        }
    }

    let isPortSetToCato = (linkData) => {
        return linkData.destType.value === 'CATO';
    }

    let hasCatoLinkOnAddOn = () => {
        return ctrl.socketSettings.links.some(link => link.destType.value === 'CATO' && ctrl.addOnInterfaceIds.includes(link.interface_id));
    }

    let hasIeplLink = () => {
        return ctrl.socketSettings.links.some(link => link.destType.value === 'IEPL')
    }

    ctrl.updateNetworkInterface = function(socketInterface) {

        handleDestTypeFrontEndErrors();
        setRoleIfNeeded(socketInterface);

        ctrl.linkDestinationChangeListener({socketInterface: socketInterface})
    };

    let setRoleIfNeeded = (socketInterface) => {
        if (socketInterface.destType){
            if (setRoleToWan2(ctrl.socketSettings, socketInterface.destType)) {
                socketInterface.role = 'wan_2';
            } else if (socketInterface.destType.value === 'DIRECT_INTERNET'){
                socketInterface.role = 'wan_1';
            } else if (socketInterface.destType.value !== 'CATO'){
                socketInterface.role = null;
            }
        }
    }

    let setRoleToWan2 = (socketSettings, destType) => {
        return (isAutomaticRole(socketSettings) && destType.value === 'CATO') || destType.value === 'IEPL';
    }

    ctrl.openSwapLinkWarning = function(firstInterface, secondInterface) {
        var message = "This action will replace between Port " + firstInterface.name + " and Port " + secondInterface.name;
        $scope.$root.confirm(message, function() {
            ctrl.swapLinks(firstInterface, secondInterface);
        });
    };

    ctrl.swapLinks = function(firstInterface, secondInterface) {
        [firstInterface.interface_id, secondInterface.interface_id] = [secondInterface.interface_id, firstInterface.interface_id];
        [firstInterface.physicalPort, secondInterface.physicalPort] = [secondInterface.physicalPort, firstInterface.physicalPort];
        [firstInterface.metadata.linkOrder, secondInterface.metadata.linkOrder] = [secondInterface.metadata.linkOrder, firstInterface.metadata.linkOrder];

        ctrl.linksSwapListener({firstInterface: firstInterface, secondInterface: secondInterface});
    };

    ctrl.precedenceChange = function (linkData) {
        if(ctrl.precedenceChangeListener) {
            ctrl.precedenceChangeListener({link: linkData})
        }
    };

    ctrl.nameChanged = function(linkData) {
        ctrl.nameChangeListener({socketInterface: linkData})
    }

    let handleDestTypeFrontEndErrors = function() {
        $scope.$root.clearErrors();
        $scope.$root.errorsNum = 0;

        let destToLinkIdArr = [];

        ctrl.socketSettings.links.forEach(link => {
            destToLinkIdArr[link.destType.value] = destToLinkIdArr[link.destType.value] ? destToLinkIdArr[link.destType.value] : [];
            destToLinkIdArr[link.destType.value].push(link.interface_id);
        });

        handleVRRPFrontEndErrors(destToLinkIdArr);
        handleLanLagFrontEndErrors(destToLinkIdArr);
    }

    let handleVRRPFrontEndErrors = function(destToLinkIdArr){

        let vvrpLinks = destToLinkIdArr.VRRP ? destToLinkIdArr.VRRP : [];
        if (destToLinkIdArr.VRRP_AND_LAN){
            vvrpLinks = vvrpLinks.concat(destToLinkIdArr.VRRP_AND_LAN)
        }
        if (destToLinkIdArr.LAN_LAG_MASTER_AND_VRRP){
            vvrpLinks = vvrpLinks.concat(destToLinkIdArr.LAN_LAG_MASTER_AND_VRRP);
        }

        if (vvrpLinks.length > 1){
            setErrorMessage(vvrpLinks, ".destType", MAX_NUM_OF_VRRP_MSG)
        }
    }

    let handleLanLagFrontEndErrors = function(destToLinkIdArr){

        let memberLagLinks = destToLinkIdArr.LAN_LAG_MEMBER ? destToLinkIdArr.LAN_LAG_MEMBER : [];
        let masterLagLinks = destToLinkIdArr.LAN_LAG_MASTER ? destToLinkIdArr.LAN_LAG_MASTER : [];
        if (destToLinkIdArr.LAN_LAG_MASTER_AND_VRRP){
            masterLagLinks = masterLagLinks.concat(destToLinkIdArr.LAN_LAG_MASTER_AND_VRRP);
        }

        if (masterLagLinks.length > 1){
            setErrorMessage(masterLagLinks, ".destType", MAX_NUM_OF_LAN_LAG_MASTER_MSG)
        }else if (masterLagLinks.length === 0 && memberLagLinks.length > 0){
            setErrorMessage(memberLagLinks, ".destType", MIN_NUM_OF_LAN_LAG_MASTER_MSG)
        }else if (memberLagLinks.length > 3){
            setErrorMessage(memberLagLinks, ".destType", MAX_NUM_OF_LAN_LAG_MEMBER_MSG)
        }else if (masterLagLinks.length + memberLagLinks.length > 4){
            setErrorMessage(masterLagLinks.concat(memberLagLinks), ".destType", MAX_NUM_OF_LAN_LAN_MSG);
        }
    }

    let setErrorMessage = function (pathArr, pathAddition,  errorMessage){
        // A timeout call a $digest after other digests have finished
        $timeout(function() {
            pathArr.forEach(path => {
                let index = path + pathAddition
                $scope.$root.errors[index] = errorMessage;
                $scope.$root.errorsNum++;
            });
        }, 0);
    }

    ctrl.isWan2Disabled = () => {
        return !isSocketType('AWS') || ctrl.socketSettings?.links?.some(link => link.interface_id === 'WAN2' && link.destType.value === 'INTERFACE_DISABLED');
    }

    ctrl.showPrimarySocketUnassignButton = () => {
        return ctrl.showUnassignButton;
    }

    let isvSocket = () => {
        return isSocketType('AWS') ||  isSocketType('AZURE') ||  isSocketType('ESX');
    }

    ctrl.showPrimarySocketUnassignButton = () => {
        return ctrl.showUnassignButton && ctrl.socketSettings?.type?.value !== null && !isSocketType('AWS') && !isSocketType('AZURE') && !isSocketType('ESX')
    }

    let isSocketType = (type) => {
        return ctrl.socketSettings?.type?.value === type;
    }

    ctrl.showRoleAndPrecedence = (destType) => {
        return destType.value === 'CATO' || isIeplOrDierctInternet(destType);
    }

    ctrl.showBandwidth = (socketSettings, destType) => {
        let primarySocketExists = socketSettings.isPrimary;
        let matchingDestTypes = destType.value === 'CATO' || destType.value === 'ALTERNATIVE' || destType.value === 'LAYER_2_WAN' || isIeplOrDierctInternet(destType);
        return primarySocketExists && matchingDestTypes;
    }

    ctrl.disableRole = (socketSettings, destType) => {
        return isAutomaticRole(socketSettings) || isIeplOrDierctInternet(destType)
    }

    ctrl.disablePrecedence = (detType) => {
        return isIeplOrDierctInternet(detType);
    }

    let isAutomaticRole = (socketSettings) => {
        return socketSettings.supportedFeatures.indexOf('INTERFACE_ROLE') < 0 && socketSettings.type.value === 'X1500';
    }

    let isIeplOrDierctInternet = (destType) => {
        return destType && (destType.value === 'IEPL' || destType.value === 'DIRECT_INTERNET');
    }
};

